import React, { useEffect, useState } from 'react';
import '../../styled/pages/dashboard.scss';
import { SideMenu, Header, Loader } from '../../components';
import { customStyles } from '../../Utils/utils';
import { getIcon, Icon } from '@ohif/ui';

import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store/store';
import { useNavigate } from 'react-router-dom';
import { getReportTemplatesApi } from '../../rtk-apis/reports/getReportTemplates';
import { clearState } from '../../store/slices/reports/getReportTemplates';

const TemplateModal = () => {
  const [templates, setTemplates] = useState([]);

  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  const { status, result, msg, loading } = useSelector(
    (state: RootState) => state.getReportTemplatesResponse
  );

  useEffect(() => {
    dispatch(
      getReportTemplatesApi({
        search: '',
        // templates_per_page: 12,
      })
    );

    return () => {
      clearState();
    };
  }, []);

  useEffect(() => {
    if (status === 'SUCCESS' && !loading) {
      setTemplates(result?.data);
    }
  }, [status, loading]);
  return (
    <section
      className="layoutContainer"
      style={customStyles.layoutBackground}
    >
      <div className="layoutGrid">
        <div className="page">
          <Header />
          <div className="page__body">
            <div className="templateDetailWrap">
              <div
                className="templateDetailWrap__head"
                style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
              >
                <h1 className="title title--h4 title--semibold">Preview Template</h1>
                <button
                  className="btn btn__primary mt-4"
                  onClick={() => navigate('/uploadtemplate')}
                  // disabled={disableUpdateButton}
                >
                  Upload Template
                </button>
              </div>
              <div className="templateCards">
                {templates?.map((template, index) => (
                  <div
                    className="templateCards__item"
                    key={template?._id}
                  >
                    <div className="templateCards__card">
                      <h3 className="title">
                        {getIcon('template-icon')}
                        {template?.templateName}
                      </h3>
                      <div
                        className="templateCards__card__row"
                        style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}
                      >
                        <div className="pdfBox">
                          <Icon name="reportPreview" />
                        </div>
                        {/* <div className="content">
                          <p>
                            In publishing and graphic design, Lorem ipsum is a placeholder text
                            commonly used to demonstrate the visual form of a document or a typeface
                            without relying on meaningful content.
                          </p>
                        </div> */}
                        <div className="btn__group">
                          <button
                            className="btn btn__primary btn--full"
                            onClick={() => {
                              navigate(`./preview/${template?._id}`, {
                                state: {
                                  _id: template?._id,
                                  editorContent: template?.templateHTML,
                                },
                              });
                            }}
                          >
                            Preview Template
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Loader isLoading={loading} />
    </section>
  );
};

export default TemplateModal;
